import React, { FC, useEffect, useState, useContext, useCallback } from 'react';
import SettingsContext from 'src/contexts/SettingsContext';
import axios from 'src/utils/axiosintercpt';
import { useHistory, useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import useIsMountedRef from 'src/hooks/useIsMountedRef';
import Breadcrumbs from './Breadcrumbs';
import Header from './InnerHeader';
import OverviewSection from './OverviewSection';
import TopColleges from './TopColleges';

import { pConfig } from 'src/config';
import Helmet from 'react-helmet';

const useStyles = makeStyles(() => ({
  root: {}
}));

const HomePage: FC = () => {
  const classes = useStyles();
  const { streamslug, slug } = useParams();
  const history = useHistory();
  const setCtx = useContext(SettingsContext);
  const [courseStreamArr, setCourseStreamArr] = useState([]);
  const [topCollegeArr, setTopCollegeArr] = useState([]);
  const [isHeroLoaded, setHeroLoaded] = useState(false);
  const [isTopColLoaded, setTopColLoaded] = useState(false);
  const isMountedRef = useIsMountedRef();
  const [coursedetail, setcoursedetail] = useState<any>({});
  const [newcourseStreamArr, setNewCourseStreamArr] = useState<any>([]);
  const [subcourse, setsubcourse] = useState<any>({});
  const [promoBannerArr, setPromoBannerArr] = useState<any>([]);
  const [metatitle, setmetatitle] = useState<string>('');
  const [metadescription, setmetadescription] = useState<string>('');

  const getHeroData = async () => {
    const formData = new FormData();
    formData.append(
      'getdata',
      JSON.stringify([{ data: 'course_streams_head' }])
    );
    const heroResp = await axios.post('api/website/home/header', formData);

    setCourseStreamArr(heroResp.data.data.course_streams_head);

    setCtx.setCourseData(heroResp.data.data.course_streams_head);
    setHeroLoaded(true);
  };

  const getsubcourse = useCallback(async () => {
    try {
      const id = slug; //'engineering';
      const response = await axios.get('api/website/home/courses/' + id);
      if (isMountedRef.current) {
        setsubcourse(response.data.data);

        //  console.log("response.data.data");
        // console.log(response.data.data);
        // setcoursedetail(response.data.data);
        setmetatitle(response.data.data.meta_title);
        setmetadescription(response.data.data.meta_description);
      }
    } catch (err) {
      console.error(err);
      history.push('/404');
    }
  }, [isMountedRef]);

  const getCollageUnivData = async () => {
    const formData = new FormData();
    formData.append('getdata', JSON.stringify([{ data: 'college' }]));
    const univColgResp = await axios.post(
      'api/website/home/topcrousel',
      formData
    );

    setTopCollegeArr(univColgResp.data.data.topcollege.data);
    setTopColLoaded(true);
  };

  const getdatabystreamid = useCallback(async () => {
    try {
      const id = streamslug; //slug;//'engineering';
      const response = await axios.get('api/admin/stream/get/' + id);
      if (isMountedRef.current) {
        // alert("asfd");
        console.log('response.data.data', response.data.data);
        // console.log(response.data.data);
        setcoursedetail(response.data.data);
        // setmetatitle(response.data.data.meta_title);
        // setmetadescription(response.data.data.stream_description);
      }
    } catch (err) {
      console.error(err);
    }
  }, [isMountedRef]);

  const getCourseData = async () => {
    const formData = new FormData();
    //formData.append('getdata', JSON.stringify([{data: "college"},{data: "university"},{data: "exam"},{data: "testimonial"}]));
    const getstreams = await axios.get(
      'api/website/home/streams?columnname=listing_order&orderby=asc&home_view_status=home_page&page=1&size=10000'
    );
    setNewCourseStreamArr(getstreams.data.data);
  };

  const getpromobanner = useCallback(async () => {
    try {
      const response = await axios.get(
        'api/website/promobanner?promo_banner=All_Exam_page'
      );
      if (isMountedRef.current) {
        setPromoBannerArr(response.data.data);
      }
    } catch (err) {
      console.error(err);
    }
  }, [isMountedRef]);

  useEffect(() => {
    getHeroData();
    getsubcourse();
    getCollageUnivData();
    //geBlogData();
    getdatabystreamid();
    getCourseData();
    //getpromobanner();
  }, []);

  return (
    <>
      {/* {isTopColLoaded ? 
      <> */}
      <Helmet>
        <title>
          {metatitle && metatitle != ''
            ? metatitle
            : 'Get Admission at Top Colleges in Bangalore'}
        </title>
        <meta
          name="description"
          content={
            metadescription && metadescription != ''
              ? metadescription
              : 'Looking for College/ University/ School admission? Bangalorestudy.com helps you with a list of Colleges, Universities and Schools to pursue your education in Bangalore. Call us now'
          }
        />
        <link
          rel="canonical"
          href={`${pConfig.siteUrl}courses/${streamslug}/${slug}`}
        />

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org/',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: `${pConfig.siteUrl}`
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Courses',
                item: `${pConfig.siteUrl}courses`
              },
              // {
              //     "@type": "ListItem",
              //     "position": 3,
              //     "name": `${subcourse?.streams?.stream_name || coursedetail?.stream_name || streamslug || ""}`,
              //     "item": `${pConfig.siteUrl}courses/${streamslug}`
              // },
              // {
              //     "@type": "ListItem",
              //     "position": 4,
              //     "name": `${subcourse?.course_stream_name || subcourse?.course_name || slug || ""}`,
              //     "item": `${pConfig.siteUrl}courses/${streamslug}/${slug}`
              // }
              {
                '@type': 'ListItem',
                position: 3,
                name: `${subcourse?.streams?.stream_name ||
                  coursedetail?.streams?.stream_name ||
                  ''}`,
                item: `${pConfig.siteUrl}courses/${subcourse?.streams
                  ?.stream_slug ||
                  coursedetail?.streams?.stream_slug ||
                  ''}`
              },
              {
                '@type': 'ListItem',
                position: 4,
                name: `${subcourse?.course_stream_name ||
                  subcourse?.course_name ||
                  ''}`,
                item: `${pConfig.siteUrl}courses/${subcourse?.streams
                  ?.stream_slug ||
                  coursedetail?.streams?.stream_slug ||
                  ''}/${slug}`
              }
            ]
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              ...(subcourse?.faqs && Array.isArray(subcourse.faqs)
                ? subcourse.faqs.map((faq: any) => ({
                    '@type': 'Question',
                    name: faq.questions || '',
                    acceptedAnswer: {
                      '@type': 'Answer',
                      text: faq.answers || ''
                    }
                  }))
                : [])
              // ...(coursedetail?.faqs && Array.isArray(coursedetail.faqs) ? coursedetail.faqs.map((faq: any) => ({
              //     "@type": "Question",
              //     "name": faq.questions || "",
              //     "acceptedAnswer": {
              //         "@type": "Answer",
              //         "text": faq.answers || ""
              //     }
              // })) : [])
            ]
          })}
        </script>
      </Helmet>
      <Header subcourse={subcourse} coursedetail={coursedetail} />
      <Breadcrumbs subcourse={subcourse} streamslug={streamslug} />
      <OverviewSection
        subcourse={subcourse}
        streamslug={streamslug}
        coursedetail={coursedetail}
        newcourseStreamArr={newcourseStreamArr}
        promoBannerArr={promoBannerArr}
      />
      {isTopColLoaded && (
        <>
          <TopColleges subcourse={subcourse} topCollegeArr={topCollegeArr} />
        </>
      )}

      {/* </>
      :
      <p style={{height: '8000px'}}>Loading</p> } */}
    </>
  );
};

export default HomePage;
